// Register all builtin overlay shapes (imports must be at top)
import drawDot      from "./dot.js";
import drawCircle   from "./circle.js";
import drawArc      from "./arc.js";
import drawSquare   from "./square.js";
import drawTriangle from "./triangle.js";
import drawLine     from "./line.js";
import drawCone     from "./cone.js";
import drawRandom   from "./random.js";

const REG = new Map();

export function registerShape(name, fn) {
  const key = String(name || "").toLowerCase();
  if (!key || typeof fn !== "function") return;
  REG.set(key, fn);
}

export function getShapeRenderer(name) {
  const key = String(name || "dot").toLowerCase();
  return REG.get(key) || REG.get("dot");
}

// default “dot” fallback if someone removes registration by mistake
if (!REG.get("dot")) {
  REG.set("dot", (g, app, { origin }) => {
    try { g.lineStyle({ width: 2, color: 0x00d4ff, alpha: 1 }); }
    catch { g.lineStyle(2, 0x00d4ff, 1); }
    g.drawCircle(origin.x, origin.y, 4);
  });
}

// Register all built-ins
registerShape("dot",      drawDot);
registerShape("circle",   drawCircle);
registerShape("arc",      drawArc);
registerShape("square",   drawSquare);
registerShape("triangle", drawTriangle);
registerShape("line",     drawLine);
registerShape("cone",     drawCone);
registerShape("random",   drawRandom);
